<div
  style="padding: 8px 5px;" 
  (mouseleave)="leaveDialog()"
  (mouseenter)="openDialog()"
>
  <p style="margin: 0">
    In order to submit your profile, you need to add at least one Technical Skill
  </p>
</div>